import request from 'utils/request';

export function putFavoriteQuestion(params, options) {
  const requestOptions = {
    ...options,
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  };
  return request(`/api/v3/favorite-questions`, requestOptions);
}

export function fetchFavoriteQuestions(params, options) {
  const requestOptions = {
    ...options,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return request(`/api/v3/favorite-questions`, requestOptions);
}
